._DateEqual_13ne0_1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
._DateEqual_13ne0_1 ._datePicker_13ne0_6,
._DateEqual_13ne0_1 ._datePicker_13ne0_6 > div {
  width: 100%;
}